import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { AutoCompleteInsertService } from "./autocomplete-insert.service";

@Component({
    selector: 'autocomplete-insert-component',
    template: require('./autocomplete-insert.component.html'),
    styles: [require('./autocomplete-insert.component.css')]
})
export class AutoCompleteInsertComponent implements OnInit {
    @Input() isRequired: boolean = true;
    @Input() isDisabled: boolean = false;
    @Input() submitted: boolean = false;
    @Input() clear: boolean = false;
    @Input() selectId: string;
    @Input() apiCustom: string = '/listar';
    @Input() placeholder: string = '— Selecione —';
    @Input() fieldToShow: string;
    @Input() label: string;
    @Input() model: any;
    @Input() query: any;
    @Input() _service: any;
    @Input() loading: boolean = false;
    @Output() setObejct: EventEmitter<any> = new EventEmitter();
    @Output() clearObject: EventEmitter<any> = new EventEmitter();

    constructor(
        private _restService: RestService,
        private _autocompleteService: AutoCompleteInsertService
    ){}

    ngOnInit() {
        var select2:any;
        select2 = $("#" + this.selectId + " select");
        this.createSelect2(select2);
    }

    private createSelect2(select2: any) {
        this.autocomplete(select2);

        select2.on('select2:select', function (evt: any) {
            this.onchangeSelect(evt);
        }.bind(this));

        select2.on('select2:open', function (evt: any) {
            this.onOpenSelect(evt);
        }.bind(this));

        select2.on('select2:unselect', function (evt: any) {
            this.clearObject.next({});
            select2.select2("close");
        }.bind(this));
    }

    private autocomplete(inputElement:any) {
        var route:string,
            Ajax:any;

        route = this._service.onGetApiUrl();
        Ajax = this._restService.getAutocompleteAjax(route, this.apiCustom);
        Ajax.data = this.processData;
        Ajax.processResults = this.processResults;
        var OptionsSelect2: any = {
            ajax: Ajax
        };

        this.createOption2(OptionsSelect2, inputElement);
    }

    private processOutResults(ResultObject: any, fieldShow: string) {
        var ObjectOut: any = {
            id: ResultObject.id
        };

        ObjectOut.text = ResultObject[fieldShow];

        return ObjectOut;
    }

    private createOption2(OptionsSelect2: any, inputElement: any) {
        OptionsSelect2.templateResult = this.templateList;
        OptionsSelect2.templateSelection = this.templateList;

        if (this.placeholder) {
            OptionsSelect2.placeholder = this.placeholder;
        }

        if (this.clear) {
            OptionsSelect2.allowClear = true;
        }

        inputElement.select2(OptionsSelect2);
    }

    private processIn = (function(params: any) {
        var ObjectIn: any;

        if (!params.term) {
            params.term = '';
        }

        var newQuery: any = JSON.stringify(this.query);
        newQuery = newQuery.replace(/REPLACEHERE/g, params.term);
        newQuery = JSON.parse(newQuery);
        ObjectIn = newQuery;

        return ObjectIn;
    }.bind(this));

    private processOut = (function (ResponseResultFind: any) {
        var processOutResults: any = this.processOutResults;
        var ObjectOut: any;

        ObjectOut = processOutResults(ResponseResultFind, this.fieldToShow);

        return ObjectOut;
    }.bind(this));

    private processData = (function (params: any) {
        var ObjectSend = this.processIn(params);
        var filter = JSON.stringify(ObjectSend);
        return filter;
    }.bind(this));

    private processResults = (function (ResultFind: any, Params: any) {
        var ResponseResultFind = ResultFind;

        Params.page = Params.page || 1;

        var Items: any[] = [];
        var indiceResult: any;
        var lengthResult: any;

        for (indiceResult = 0, lengthResult = ResponseResultFind.length; indiceResult < lengthResult; indiceResult++) {
            var Item = this.processOut(ResponseResultFind[indiceResult]);
            Items.push(Item);
        }

        var text: string = "";
        if (Params.term) {
            text = Params.term;
        }

        //add a linha de para criar novo
        Items.push({id: -1, text: text});

        return {
            results: Items,
            pagination: {
                more: (Params.page * 30) < lengthResult
            }
        };
    }.bind(this));

    private onchangeSelect = (function($event: any) {
        if ($event.params) {
            var thisValue:any = $event.params.data;
            if (thisValue.id) {
                if (thisValue.id === -1) {
                    this.model = {novo: true, text: thisValue.text};
                } else {
                    //se for text/id
                    this.model = {id: thisValue.id, text: thisValue.text};
                }
            } else {
                this.model = null;
            }

            this.setObejct.next(this.model);
        }
    }.bind(this));

    private onOpenSelect = (function($event: any) {
        setTimeout(function () {
            var element:any = document.getElementById("select2-insertElement");
            if (!element) {
                var div:any = document.createElement("DIV");
                div.id = "select2-insertElement";
                $(".select2-results").append(div);
            }
        });

    }.bind(this));

    private templateList = (function(state: any) {
        var stateReturn: any,
            text: string;

        if (state.loading) {
            stateReturn = state.text;
        } else {
            if (state.id === -1) {
                stateReturn = this._autocompleteService.setNewTagInList(state);
            } else {
                text = state.text;
                stateReturn = $('<span>' + text + '</span>');
            }
        }

        return stateReturn;
    }.bind(this));

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/components/autocomplete-insert/autocomplete-insert.component.ts
 **/